import { render } from "./ConfiguracaoInicialProdutos.vue?vue&type=template&id=1d52048d&scoped=true&ts=true"
import script from "./ConfiguracaoInicialProdutos.vue?vue&type=script&lang=ts"
export * from "./ConfiguracaoInicialProdutos.vue?vue&type=script&lang=ts"

import "./ConfiguracaoInicialProdutos.vue?vue&type=style&index=0&id=1d52048d&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d52048d"]])

export default __exports__